import { router } from '@router/index.js';
import { languageChanged } from '@signals/viewer';
import { UISelect } from '@ui';
import i18next from 'i18next';
import localeEN from '/static/locales/en.js';
import localeKR from '/static/locales/kr.js';

const options = {
  en: 'English',
  kr: '한국어',
};

const languageToLocale = {
  en: 'en-US',
  kr: 'ko-KR',
};

function initialize(language) {
  const validLanguage = options[language] ? language : 'en'; // Default to 'en' if language is invalid
  i18next.init({
    lng: validLanguage,
    debug: false,
    resources: {
      en: { translation: localeEN },
      kr: { translation: localeKR },
    },
  });
  window.i18next = i18next;
}

class LanguageSelector extends UISelect {
  constructor() {
    super();
    this.#buildSelector();
  }

  #buildSelector() {
    let lang = localStorage.getItem('selectedLanguage');
    if (!lang || !options[lang]) {
      lang = 'en';
      localStorage.setItem('selectedLanguage', lang);
    }

    this.setOptions(options);
    this.setValue(lang);

    this.onChange(() => {
      const value = this.getValue();
      localStorage.setItem('selectedLanguage', value);
      i18next.changeLanguage(value);
      languageChanged.dispatch();
      router();
    });
  }
}

export { initialize, LanguageSelector, languageToLocale };
